(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function() {
    /*********** copy infographic to clipboard *********/
    var infographicForm = document.querySelector('.infographic-form');

    infographicForm.addEventListener('submit', function(e) {
        e.preventDefault();

        var infographicAddress = infographicForm.querySelector('input[type="text"]'),
            $tmp = infographicAddress.value;
            copied = infographicAddress.dataset.copied;

        infographicAddress.select();
        document.execCommand('copy');

        infographicAddress.disabled = true;
        infographicAddress.value = copied;
        setTimeout(function() {
            infographicAddress.disabled = false;
            infographicAddress.value = $tmp;
        }, 2000);
    });
});